import React, { Component } from 'react'
import PropTypes from 'react-proptypes'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { validate } from 'components/Forms/Validation'
import Notification from 'components/Notification'
import FullscreenLoader from 'components/Loader'
import { authenticateUser } from 'actions/auth'
import { setAppAttribute } from 'actions/app'
import logo from '../../assets/img/svg/logo.svg'

@connect(state => ({
  auth: state.auth.get('data'),
  app: state.app.get('attribute'),
  errorMessage: state.auth.get('errorMessage'),
  loading: state.auth.get('loading'),
}))
@reduxForm({
  form: 'login',
  validate,
})

class Login extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    params: PropTypes.object,
    errorMessage: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    valid: PropTypes.bool, // from redux-form
    handleSubmit: PropTypes.func.isRequired, // from redux-form
    router: PropTypes.object.isRequired, // from react-router HOC
    dispatch: PropTypes.func, // from react-redux connect
  }
  static defaultProps = {
    errorMessage: null,
    valid: true,
    dispatch: null,
    params: {},
  }

  componentWillReceiveProps() {
    const { dispatch, auth, router, params } = this.props
    const authenticated = auth.get('authenticated')
    const isRedirectAvailable = typeof params.redirect !== 'undefined'

    if (!authenticated && isRedirectAvailable) {
      dispatch(setAppAttribute('landingPage', `${ params.redirect }/${ params.refId }`))
    } else if (authenticated && isRedirectAvailable) {
      router.push(`/${ params.redirect }/${ params.refId ? params.refId : '' }`)
    }
  }

  shouldComponentUpdate(nextProps) {
    return !this.props.auth.size || this.props.auth !== nextProps.auth
  }

  handleFormSubmit = (values) => {
    const { dispatch, router } = this.props
    dispatch(authenticateUser(values, router))
  }

  renderField = ({ input, name, placeholder, className, type, meta: { touched, error } }) => (
    <fieldset className='form-group'>
      <div>
        <input { ...input } placeholder={ placeholder } className={ className } type={ type } name={ name } />
        {touched && error && <span className='validation-message'>{error}</span>}
      </div>
    </fieldset>
  )

  render() {
    const { loading } = this.props
    return (
      <div id='LOGIN' className='container'>
        <FullscreenLoader
          Show={ loading }
          Copy={ ['Logging In', 'Preparing Reservations'] }
        />
        <div className='marTop-4'>
          <div className='logo-container marBot-1'>
            <img src={ logo } alt='globeo logo' className='globeo-logo' />
          </div>
          <Notification />
          <form onSubmit={ this.props.handleSubmit(this.handleFormSubmit) }>
            <Field name='email' component={ this.renderField } className='form-control login' type='text' placeholder='Email Address' />
            <Field name='password' component={ this.renderField } className='form-control login ico-lock' type='password' placeholder='Password' />
            <div className='btn-cluster padBot-3'>
              <button action='submit' id='login-submit' className='btn btn-honey btn-honey-onhover'>Log In</button>
            </div>
            <Link to='/forgot-password' className='center text-center forgot-your-pw'>Forgot your password?</Link>
          </form>
          <h7 className='center text-center padTop-7 phone-support'>24/7/365 Support</h7>
          <a href='tel:1-866-645-8400' className='center text-center phone-number'>(866) 645–8400</a>
        </div>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx